export const userPermissions = {
  USER_VIEW: {
    enabled: ['user_view', 'user_edit'],
  },
  USER_EDIT: {
    enabled: ['user_edit'],
    disabled: ['user_view'],
  },
};
